"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.analyseDataPattern = void 0;
const isString_1 = __importDefault(require("lodash/isString"));
const isPlainObject_1 = __importDefault(require("lodash/isPlainObject"));
const isNumber_1 = __importDefault(require("lodash/isNumber"));
const isBoolean_1 = __importDefault(require("lodash/isBoolean"));
const isArray_1 = __importDefault(require("lodash/isArray"));
const dbgate_tools_1 = require("dbgate-tools");
function detectValueType(value) {
    if ((0, isString_1.default)(value))
        return 'string';
    if ((0, isNumber_1.default)(value))
        return 'number';
    if ((0, isBoolean_1.default)(value))
        return 'boolean';
    if (value === null || value === void 0 ? void 0 : value.$oid)
        return 'oid';
    if ((0, isPlainObject_1.default)(value) || (0, isArray_1.default)(value))
        return 'json';
    if (value == null)
        return 'null';
}
function addObjectToColumns(columns, row) {
    if ((0, isPlainObject_1.default)(row)) {
        for (const key of Object.keys(row)) {
            let column = columns.find(x => x.name == key);
            if (!column) {
                column = {
                    name: key,
                    types: [],
                    columns: [],
                };
                columns.push(column);
            }
            const value = row[key];
            const type = detectValueType(value);
            if (!column.types.includes(type)) {
                column.types.push(type);
            }
            if ((0, isPlainObject_1.default)(value) && type != 'oid') {
                addObjectToColumns(column.columns, value);
            }
            if ((0, isArray_1.default)(value)) {
                for (const item of value) {
                    addObjectToColumns(column.columns, item);
                }
            }
            if ((0, isString_1.default)(value)) {
                const json = (0, dbgate_tools_1.safeJsonParse)(value);
                if (json && ((0, isPlainObject_1.default)(json) || (0, isArray_1.default)(json))) {
                    if (!column.types.includes('json')) {
                        column.types.push('json');
                    }
                    if ((0, isPlainObject_1.default)(json)) {
                        addObjectToColumns(column.columns, json);
                    }
                    if ((0, isArray_1.default)(json)) {
                        for (const item of json) {
                            addObjectToColumns(column.columns, item);
                        }
                    }
                }
            }
        }
    }
}
function analyseDataPattern(patternBase, rows) {
    const res = Object.assign(Object.assign({}, patternBase), { columns: [] });
    // console.log('ROWS', rows);
    for (const row of rows) {
        addObjectToColumns(res.columns, row);
    }
    return res;
}
exports.analyseDataPattern = analyseDataPattern;
